/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, DatePicker, message, Drawer, Form, Upload, Icon } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false,
			defaultFileList: []
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
		this.disabledDate = this.disabledDate.bind(this)
		this.handleDeleteAttachment = this.handleDeleteAttachment.bind(this)
	}

	componentDidMount() {
		const { selectedProject } = this.props
		let defaultFileList = []
		if (selectedProject) {
			defaultFileList = selectedProject.project_attachments.map((attachment, key) => {
				return {
					uid: attachment._pivot_file_uid,
					project_uid: attachment._pivot_project_uid,
					name: attachment.originalname,
					status: 'done',
					url: `${process.env.REACT_APP_BACKEND_API}${attachment.url}`,
					fromServer: true
				}
			})
			this.setState({ defaultFileList })
		}
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		if (_.has(nextProps, 'selectedProject') && _.has(nextProps.selectedProject, 'project_attachments')) {
			const defaultFileList = nextProps.selectedProject.project_attachments.map((attachment) => {
				return {
					uid: attachment._pivot_file_uid,
					project_uid: attachment._pivot_project_uid,
					name: attachment.originalname,
					status: 'done',
					url: `${process.env.REACT_APP_BACKEND_API}${attachment.url}`,
					fromServer: true
				}
			})
		  return ({ defaultFileList }) // <- this is setState equivalent
		}
		return null
	  }
    
	handleSubmit(e) {
		e.preventDefault()
		const { form, AuthStore, saveProject, onClose, selectedProject } = this.props
		const { barangay_uid } = AuthStore
		const { resetFields } = form
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}
			const fileList = _.has(values.attachments, 'fileList') ? values.attachments.fileList : []
			const formattedFiles = fileList.map((mFile) => mFile.originFileObj).filter((i) => i !== undefined)
			delete values.attachments

			const date_start = moment(values.date_start).format('YYYY-MM-DD')
			const date_end = values.date_end ? moment(values.date_end).format('YYYY-MM-DD') : null
			let params = Object.assign({}, values, { 
				barangay_uid, date_start, date_end, 
				files: formattedFiles
			})
			if (selectedProject) {
				params = Object.assign({}, params, { project_uid: selectedProject.uid })
			}
			console.log('params', params)

			message.loading({ key: 'set_project', content: 'Saving project, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveProject(params).then((response) => {
					this.setState({ isSaving: false })
					message.success({ key: 'set_project', content: 'Project successfully saved.' })

					//create audit trail
					const auditParams = {
						module_name: 'Management',
						action: (selectedProject) ? 'Update' : 'Create',
						message: (selectedProject) ? 
							`Update project ${params.project_name} details` : 
							`Created new project ${params.project_name}`
					}
					AuthStore.saveAuditTrail(auditParams)

					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error saving project')
					message.error({ key: 'set_project', content: err.message.replace('GraphQL error:', '') })
					resetFields()
				})
			})
		})
	}

	disabledDate (value) {
		return value < moment(new Date(), 'YYYY-MM-DD').subtract(1, 'day')
		// return value < moment(new Date(), 'YYYY-MM-DD')
	}

	handleDeleteAttachment (project_uid, file_uid) {
		const { deleteAttachment } = this.props

		message.loading({ key: 'delete_attachment', content: 'Deleting Attachment, please wait..' })
		deleteAttachment({ project_uid, file_uid }).then((response) => {
			message.success({ key: 'delete_attachment', content: 'Attachment successfully deleted.' })
		}).catch(err => {
			console.log('error deleting attachment')
			message.error({ key: 'delete_attachment', content: err.message.replace('GraphQL error:', '') })
		})
	}

	render() {
		const { defaultFileList } = this.state
		const { 
			visible, onClose, form, selectedProject
		} = this.props
		const { getFieldDecorator } = form
		
		var that = this
		const fileProps = {
			name: 'file',
			multiple: true,
			onChange(info) {
				if (_.isEqual(info.file.status, 'removed')) {
					console.log('file removed', info.file)
					if (_.has(info.file, 'fromServer') && info.file.fromServer) {
						that.handleDeleteAttachment(info.file.project_uid, info.file.uid)
					}
				}
			},
			beforeUpload (file, fileList) { return false },
			showUploadList: true,
			accept: 'image/jpeg, image/png',
			listType: 'picture-card'
		}

		const uploadButton = (
			<div>
			  <Icon type="plus" />
			  <div className="ant-upload-text">Upload</div>
			</div>
		)

		return (
			<Drawer
				title="Project Management"
				placement="right"
				// closable={false}
				onClose={onClose}
				visible={visible}
				width={'50%'}
				bodyStyle={{ maxHeight: '90%', overflow: 'scroll' }}
			>
				<Form onSubmit={this.handleSubmit}>
					<Row>
						<Form.Item label='Project'>
							{ getFieldDecorator('project_name', {
								initialValue: (selectedProject) ? selectedProject.project_name : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter Project name'/>
							)}
						</Form.Item>
					</Row>
					<Row>
						<Form.Item label='Description'>
							{ getFieldDecorator('project_description', {
								initialValue: (selectedProject) ? selectedProject.project_description : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter Project description'/>
							)}
						</Form.Item>
					</Row>
					<Row gutter={16}>
						<Col md={12} sm={24}>
							<Form.Item label='Date Started'>
								{ getFieldDecorator('date_start', {
									initialValue: (selectedProject) ? 
										moment(new Date(selectedProject.date_start)) : 
									    moment(new Date()),
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<DatePicker 
										// showTime
										format='ll'
										style={{ width: '100%' }}
										// disabledDate={this.disabledDate}
									/>
								)}
							</Form.Item>
						</Col>
						<Col md={12} sm={24}>
							<Form.Item label='Date accomplished'>
								{ getFieldDecorator('date_end', {
									initialValue: (selectedProject) ? 
										moment(new Date(selectedProject.date_end)) : 
										moment(new Date()),
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<DatePicker 
										// showTime
										format='ll'
										style={{ width: '100%' }}
										// disabledDate={this.disabledDate}
									/>
								)}
							</Form.Item>
						</Col>
					</Row>
					<Row>
						<Form.Item label='Remarks'>
							{ getFieldDecorator('remarks', {
								initialValue: (selectedProject) ? selectedProject.remarks : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input.TextArea rows={4} placeholder='Enter Remarks'/>
							)}
						</Form.Item>
					</Row>
					<Row>
						<Form.Item label='Attachments'>
							{ getFieldDecorator('attachments', {
								//initialValue: (selectedProject) ? selectedProject.remarks : null,
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Upload
									defaultFileList={defaultFileList}
									{ ... fileProps }
								>
									{uploadButton}
								</Upload>
							)}
						</Form.Item>
					</Row>
				</Form>
				<div
					style={{
						position: 'absolute',
						right: 0,
						bottom: 10,
						width: '100%',
						borderTop: '1px solid #e9e9e9',
						padding: '10px 16px',
						background: '#fff',
						textAlign: 'center',
					}}
				>
					<button type="button" className="btn btn-block btn-primary btn-rounded waves-effect waves-light" onClick={this.handleSubmit}>Save</button>
				</div>
			</Drawer>
		)
	}
}

const SET_PROJECT = gql`
    mutation setProject($input: JSON) {
		setProject(input: $input)
    }
`
const DELETE_PROJECT_ATTACHMENT = gql`
    mutation deleteProjectAttachment($input: JSON) {
		deleteProjectAttachment(input: $input)
    }
`

const composed = compose(
	Form.create({ name: 'form-barangay-projects' }),
	inject('AuthStore'),
	graphql(SET_PROJECT, {
		props({ mutate }) {
			return {
				saveProject(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['allProjects']
					})
				}
			}
		}
	}),
	graphql(DELETE_PROJECT_ATTACHMENT, {
		props({ mutate }) {
			return {
				deleteAttachment(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['allProjects']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
